"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonSDK_1 = require("../../../CarbonSDK");
const util_1 = require("../../../util");
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const gov_1 = require("../../../codec/cosmos/gov/v1beta1/gov");
const TxTypes = {
    SubmitProposal: "cosmos-sdk/MsgSubmitProposal",
    Deposit: "cosmos-sdk/MsgDeposit",
    Vote: "cosmos-sdk/MsgVote",
};
const ContentTypes = {
    [util_1.GovUtils.ProposalTypes.CreateToken]: "coin/CreateTokenProposal",
    [util_1.GovUtils.ProposalTypes.SetMsgGasCost]: "fee/SetMsgGasCostProposal",
    [util_1.GovUtils.ProposalTypes.SetMinGasPrice]: "fee/SetMinGasPriceProposal",
    [util_1.GovUtils.ProposalTypes.RemoveMsgGasCost]: "fee/RemoveMsgGasCostProposal",
    [util_1.GovUtils.ProposalTypes.RemoveMinGasPrice]: "fee/RemoveMinGasPriceProposal",
    [util_1.GovUtils.ProposalTypes.SetCommitmentCurve]: "liquiditypool/SetCommitmentCurveProposal",
    [util_1.GovUtils.ProposalTypes.SetRewardCurve]: "liquiditypool/SetRewardCurveProposal",
    [util_1.GovUtils.ProposalTypes.SetRewardsWeights]: "liquiditypool/SetRewardsWeightsProposal",
    [util_1.GovUtils.ProposalTypes.UpdatePool]: "liquiditypool/UpdatePoolProposal",
    [util_1.GovUtils.ProposalTypes.UpdateMarket]: "market/UpdateMarketProposal",
    [util_1.GovUtils.ProposalTypes.CreateOracle]: "oracle/CreateOracleProposal",
    [util_1.GovUtils.ProposalTypes.SettlementPrice]: "pricing/SettlementPriceProposal",
    [util_1.GovUtils.ProposalTypes.CreateGroup]: "coin/CreateGroupProposal",
    [util_1.GovUtils.ProposalTypes.UpdateGroup]: "coin.UpdateGroupProposal",
    [util_1.GovUtils.ProposalTypes.RegisterToGroup]: "coin/RegisterToGroupProposal",
    [util_1.GovUtils.ProposalTypes.DeregisterFromGroup]: "coin.DeregisterFromGroupProposal",
    [util_1.GovUtils.ProposalTypes.WithdrawFromGroup]: "coin/WithdrawFromGroupProposal",
    [util_1.GovUtils.ProposalTypes.UpdateGroupTokenConfig]: "coin.UpdateGroupTokenConfigProposal",
};
const SubmitProposalMsg = {
    aminoType: TxTypes.SubmitProposal,
    valueMap: {},
};
const MsgDeposit = {
    aminoType: TxTypes.Deposit,
    valueMap: {
        proposalId: utils_1.ConvertEncType.Long,
    },
};
const MsgVote = {
    aminoType: TxTypes.Vote,
    valueMap: {
        proposalId: utils_1.ConvertEncType.Long,
    },
};
const CreateToken = {
    value: {
        msg: {
            decimals: utils_1.ConvertEncType.Long,
            chainId: utils_1.ConvertEncType.Long,
            bridgeId: utils_1.ConvertEncType.Long,
        },
    },
};
const CreateGroup = {
    value: {
        msg: {
            creator: utils_1.ConvertEncType.Long,
            name: utils_1.ConvertEncType.Long,
            chequeTokenSymbol: utils_1.ConvertEncType.Long,
            oraclieId: utils_1.ConvertEncType.Long,
        },
    },
};
const UpdateGroup = {
    value: {
        msg: {
            creator: utils_1.ConvertEncType.Long,
            groupId: utils_1.ConvertEncType.Long,
            updateGroupParams: {
                name: utils_1.ConvertEncType.Long,
            },
        },
    },
};
const RegisterToGroup = {
    value: {
        msg: {
            creator: utils_1.ConvertEncType.Long,
            groupId: utils_1.ConvertEncType.Long,
            denom: utils_1.ConvertEncType.Long,
        },
    },
};
const DeregisterFromGroup = {
    value: {
        msg: {
            creator: utils_1.ConvertEncType.Long,
            groupId: utils_1.ConvertEncType.Long,
            denom: utils_1.ConvertEncType.Long,
        },
    },
};
const UpdateGroupConfig = {
    value: {
        msg: {
            creator: utils_1.ConvertEncType.Long,
            denom: utils_1.ConvertEncType.Long,
            updatedGroupedTokenConfigParams: {
                isActive: utils_1.ConvertEncType.Long,
            },
        },
    },
};
const UpdatePool = {
    value: {
        msg: {
            poolId: utils_1.ConvertEncType.Long,
            swapFee: utils_1.ConvertEncType.Dec,
            numQuotes: utils_1.ConvertEncType.Long,
        },
    },
};
const CreateOracle = {
    value: {
        msg: {
            minTurnoutPercentage: utils_1.ConvertEncType.Long,
            maxResultAge: utils_1.ConvertEncType.Long,
            resolution: utils_1.ConvertEncType.Long,
        },
    },
};
const SetCommitmentCurve = {
    value: {
        msg: {
            maxDuration: utils_1.ConvertEncType.Long,
        },
    },
};
const SetRewardCurve = {
    value: {
        msg: {
            startTime: utils_1.ConvertEncType.Date,
            reductionIntervalSeconds: utils_1.ConvertEncType.Long,
        },
    },
};
const SetRewardWeights = {
    value: {
        msg: {
            poolId: utils_1.ConvertEncType.Long,
        },
    },
};
const UpdateMarket = {
    value: {
        msg: {
            tickSize: utils_1.ConvertEncType.Dec,
            makerFee: utils_1.ConvertEncType.Dec,
            takerFee: utils_1.ConvertEncType.Dec,
            initialMarginBase: utils_1.ConvertEncType.Dec,
            initialMarginStep: utils_1.ConvertEncType.Dec,
            maintenanceMarginRatio: utils_1.ConvertEncType.Dec,
            maxLiquidationOrderDuration: utils_1.ConvertEncType.Duration,
        },
    },
};
const SettlementPrice = {
    value: {
        msg: {
            settlementPrice: utils_1.ConvertEncType.Dec,
        },
    },
};
const preProcessAmino = (value, valueMap) => {
    return utils_1.mapEachIndiv(value, valueMap, false);
};
const checkDecodeProposal = (content, amino) => {
    const decodedValue = util_1.GovUtils.decodeContent(content);
    const newContent = {
        type: ContentTypes[content.typeUrl],
        value: decodedValue.value,
    };
    const newAmino = Object.assign({}, amino);
    switch (content.typeUrl) {
        case util_1.GovUtils.ProposalTypes.UpdatePool:
            newAmino.content = Object.assign({}, UpdatePool);
            break;
        case util_1.GovUtils.ProposalTypes.CreateToken:
            newAmino.content = Object.assign({}, CreateToken);
            break;
        case util_1.GovUtils.ProposalTypes.CreateGroup:
            newAmino.content = Object.assign({}, CreateGroup);
            break;
        case util_1.GovUtils.ProposalTypes.UpdateGroup:
            newAmino.content = Object.assign({}, UpdateGroup);
            break;
        case util_1.GovUtils.ProposalTypes.RegisterToGroup:
            newAmino.content = Object.assign({}, RegisterToGroup);
            break;
        case util_1.GovUtils.ProposalTypes.DeregisterFromGroup:
            newAmino.content = Object.assign({}, DeregisterFromGroup);
            break;
        case util_1.GovUtils.ProposalTypes.UpdateGroupTokenConfig:
            newAmino.content = Object.assign({}, UpdateGroupConfig);
            break;
        case util_1.GovUtils.ProposalTypes.SetCommitmentCurve:
            newAmino.content = Object.assign({}, SetCommitmentCurve);
            break;
        case util_1.GovUtils.ProposalTypes.SetRewardCurve:
            newAmino.content = Object.assign({}, SetRewardCurve);
            break;
        case util_1.GovUtils.ProposalTypes.SetRewardsWeights:
            newAmino.content = Object.assign({}, SetRewardWeights);
            break;
        case util_1.GovUtils.ProposalTypes.SetMsgGasCost:
            newAmino.content = {};
            break;
        case util_1.GovUtils.ProposalTypes.SetMinGasPrice:
            newAmino.content = {};
            break;
        case util_1.GovUtils.ProposalTypes.RemoveMsgGasCost:
            newAmino.content = {};
            break;
        case util_1.GovUtils.ProposalTypes.RemoveMinGasPrice:
            newAmino.content = {};
            break;
        case util_1.GovUtils.ProposalTypes.SettlementPrice:
            newAmino.content = Object.assign({}, SettlementPrice);
            break;
        case util_1.GovUtils.ProposalTypes.CreateOracle:
            newAmino.content = Object.assign({}, CreateOracle);
            break;
        case util_1.GovUtils.ProposalTypes.UpdateMarket:
            newAmino.content = Object.assign({}, UpdateMarket);
            break;
        case util_1.GovUtils.ProposalTypes.Text:
            newAmino.content = {};
            break;
        default:
            break;
    }
    return {
        newContent,
        newAmino,
    };
};
const checkEncodeProposal = (content, amino) => {
    switch (content.type) {
        case ContentTypes[util_1.GovUtils.ProposalTypes.UpdatePool]: {
            const updatePoolMsg = preProcessAmino(content.value.msg, UpdatePool.value.msg);
            const updatePoolProp = CarbonSDK_1.Carbon.Liquiditypool.UpdatePoolProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: updatePoolMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.UpdatePool,
                    value: CarbonSDK_1.Carbon.Liquiditypool.UpdatePoolProposal.encode(updatePoolProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.CreateToken]: {
            const createTokenMsg = preProcessAmino(content.value.msg, CreateToken.value.msg);
            const createTokenProp = CarbonSDK_1.Carbon.Coin.CreateTokenProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: createTokenMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.CreateToken,
                    value: CarbonSDK_1.Carbon.Coin.CreateTokenProposal.encode(createTokenProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SetMsgGasCost]: {
            const setMsgGasCostMsg = preProcessAmino(content.value.msg, {});
            const setMsgGasCostProp = CarbonSDK_1.Carbon.Fee.SetMsgGasCostProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: setMsgGasCostMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SetMsgGasCost,
                    value: CarbonSDK_1.Carbon.Fee.SetMsgGasCostProposal.encode(setMsgGasCostProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SetMinGasPrice]: {
            const setMinGasPriceMsg = preProcessAmino(content.value.msg, {});
            const setMinGasPriceProp = CarbonSDK_1.Carbon.Fee.SetMinGasPriceProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: setMinGasPriceMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SetMinGasPrice,
                    value: CarbonSDK_1.Carbon.Fee.SetMinGasPriceProposal.encode(setMinGasPriceProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.RemoveMsgGasCost]: {
            const removeMsgGasCostMsg = preProcessAmino(content.value.msg, {});
            const removeMsgGasCostProp = CarbonSDK_1.Carbon.Fee.RemoveMsgGasCostProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: removeMsgGasCostMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.RemoveMsgGasCost,
                    value: CarbonSDK_1.Carbon.Fee.RemoveMsgGasCostProposal.encode(removeMsgGasCostProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.RemoveMinGasPrice]: {
            const removeMinGasPriceMsg = preProcessAmino(content.value.msg, {});
            const removeMinGasPriceProp = CarbonSDK_1.Carbon.Fee.RemoveMinGasPriceProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: removeMinGasPriceMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.RemoveMinGasPrice,
                    value: CarbonSDK_1.Carbon.Fee.RemoveMinGasPriceProposal.encode(removeMinGasPriceProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SetCommitmentCurve]: {
            const setCommitCurveMsg = preProcessAmino(content.value.msg, SetCommitmentCurve.value.msg);
            const commitCurveProp = CarbonSDK_1.Carbon.Liquiditypool.SetCommitmentCurveProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: setCommitCurveMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SetCommitmentCurve,
                    value: CarbonSDK_1.Carbon.Liquiditypool.SetCommitmentCurveProposal.encode(commitCurveProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SetRewardCurve]: {
            const setRewardCurveMsg = preProcessAmino(content.value.msg, SetRewardCurve.value.msg);
            const rewardCurveProp = CarbonSDK_1.Carbon.Liquiditypool.SetRewardCurveProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: setRewardCurveMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SetRewardCurve,
                    value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardCurveProposal.encode(rewardCurveProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SetRewardsWeights]: {
            const setRewardWeightsMsg = preProcessAmino(content.value.msg, SetRewardWeights.value.msg);
            const rewardWeightsProp = CarbonSDK_1.Carbon.Liquiditypool.SetRewardsWeightsProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: setRewardWeightsMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SetRewardsWeights,
                    value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardsWeightsProposal.encode(rewardWeightsProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.SettlementPrice]: {
            const settlementMsg = preProcessAmino(content.value.msg, SettlementPrice.value.msg);
            const settlementProp = CarbonSDK_1.Carbon.Pricing.SettlementPriceProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: settlementMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.SettlementPrice,
                    value: CarbonSDK_1.Carbon.Pricing.SettlementPriceProposal.encode(settlementProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.CreateOracle]: {
            const createOracleMsg = preProcessAmino(content.value.msg, CreateOracle.value.msg);
            const createOracleProp = CarbonSDK_1.Carbon.Oracle.CreateOracleProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: createOracleMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.CreateOracle,
                    value: CarbonSDK_1.Carbon.Oracle.CreateOracleProposal.encode(createOracleProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.UpdateMarket]: {
            const updateMarketMsg = preProcessAmino(content.value.msg, UpdateMarket.value.msg);
            const updateMarketProp = CarbonSDK_1.Carbon.Market.UpdateMarketProposal.fromPartial(Object.assign(Object.assign({}, content.value), { msg: updateMarketMsg }));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.UpdateMarket,
                    value: CarbonSDK_1.Carbon.Market.UpdateMarketProposal.encode(updateMarketProp).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        case ContentTypes[util_1.GovUtils.ProposalTypes.Text]: {
            const textProposal = gov_1.TextProposal.fromPartial(Object.assign({}, content.value));
            return {
                newContent: {
                    typeUrl: util_1.GovUtils.ProposalTypes.Text,
                    value: gov_1.TextProposal.encode(textProposal).finish(),
                },
                newAmino: Object.assign({}, amino),
            };
        }
        default:
            return {
                newContent: {
                    typeUrl: "",
                    value: new Uint8Array(),
                },
                newAmino: Object.assign({}, amino),
            };
    }
};
const proposalAminoProcess = {
    toAminoProcess: (amino, input) => {
        const { content } = input;
        const propResponse = checkDecodeProposal(content, amino);
        return {
            amino: propResponse.newAmino,
            input: Object.assign(Object.assign({}, input), { content: propResponse.newContent }),
        };
    },
    fromAminoProcess: (amino, input) => {
        const { content } = input;
        const propResponse = checkEncodeProposal(content, amino);
        return {
            amino: propResponse.newAmino,
            input: Object.assign(Object.assign({}, input), { content: propResponse.newContent }),
        };
    },
};
const GovAmino = {
    [CarbonTx.Types.MsgSubmitProposal]: utils_1.generateAminoType(SubmitProposalMsg, proposalAminoProcess),
    [CarbonTx.Types.MsgDeposit]: utils_1.generateAminoType(MsgDeposit),
    [CarbonTx.Types.MsgVote]: utils_1.generateAminoType(MsgVote),
};
exports.default = GovAmino;
